module.exports = __webpack_public_path__ + "img/mortals_vicventura21.3ce3003.png";